export default "__VITE_ASSET__2d7474b0__"